// extracted by mini-css-extract-plugin
export var brand = "_51-9";
export var compact = "_51-6";
export var extraSmall = "_51-7";
export var icon = "_51-0";
export var large = "_51-4";
export var light = "_51-1";
export var medium = "_51-5";
export var outline = "_51-b";
export var primaryDark = "_51-a";
export var primaryLight = "_51-8";
export var primaryModern = "_51-c";
export var success = "_51-2";
export var successSolid = "_51-3";